import script from "./ContentSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentSelector.vue?vue&type=script&setup=true&lang=js"

import "./ContentSelector.vue?vue&type=style&index=0&id=7767ea62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7767ea62"]])

export default __exports__